export function sanitizeMentionMsg(inputString: string) {
	return inputString.replace(/<[^>]*>/g, '');
}
